module.exports = __webpack_public_path__ + "static/media/mv_resume_new.b0abf65a.pdf";